export const powerBiConstants = {
    GET_REPORTS_REQUEST: "GET_REPORTS_REQUEST",
    GET_REPORTS_SUCCESS: "GET_REPORTS_SUCCESS",
    GET_REPORTS_LOADING: "GET_REPORTS_LOADING",
    POWERBI_REPORTS_CLEAR: "POWERBI_REPORTS_CLEAR"
}